import { useEffect, useState } from "react";
import { useGetFeatureFlagsQuery } from "../../services/feature-flags/feature-flags.service";
import { useAppDispatch } from "../../store";
import { setFeatureFlags } from "../../store/active-feature-flags";
import { useActiveFeatureFlags } from "./../../hooks/index";

export function useFeatureFlags() {
  const { activeFeatureFlags } = useActiveFeatureFlags();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>();
  const data = useGetFeatureFlagsQuery("", {
    pollingInterval: 30000
  });

  useEffect(() => {
    dispatch(setFeatureFlags(data.data));
    setIsLoading(data.isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.data, data.isLoading]);
  return {
    featuresFlags: activeFeatureFlags,
    isLoading
  };
}
